import { Icon } from "icons";
import { type PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

interface Props extends PropsWithChildren {
  comingSoon?: boolean;
}

export function BillingFeatureItem(props: Props) {
  const { t } = useTranslation();

  return (
    <li className="flex items-center gap-3">
      <Icon name="tabler-check" className="h-5 w-5 shrink-0 text-emerald-500" />
      <span className="text-sm text-gray-700">{props.children}</span>
      {props.comingSoon && (
        <span className="rounded-full bg-szt-green px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-szt-black">
          {t("pricing.comingSoon")}
        </span>
      )}
    </li>
  );
}
